import cx from "classnames";
import { type FC, type MutableRefObject, type PropsWithChildren } from "react";

export interface TableCellValueInputClickMaskProps {
	renderAsRowDetail?: boolean;
	cellValueRef?: MutableRefObject<HTMLDivElement>;
	onDoubleClick: () => void;
	isEditing: boolean;
}

export const TableCellValueInputClickMask: FC<
	PropsWithChildren<TableCellValueInputClickMaskProps>
> = ({ renderAsRowDetail, onDoubleClick, isEditing, cellValueRef, children }) => {
	return (
		<div
			onDoubleClick={onDoubleClick}
			onKeyDown={() => {
				if (!isEditing) {
					onDoubleClick();
				}
			}}
			className={cx(
				"focus:outline-none",
				"transition-none",
				renderAsRowDetail && "px-2 py-1.5 text-sm",
				!renderAsRowDetail && "w-full min-h-[20px]"
			)}
			ref={cellValueRef}
			role="button"
			tabIndex={0}
		>
			{children}
		</div>
	);
};
